import ReadingTypeModel from '../Apis/ReadingType'
import Controller from './Controller'

export default class ReadingTypeController extends Controller {
  constructor() {
    super(new ReadingTypeModel())
  }
}
